import { render } from "./DemandTemplateDetailsSectionDetails.vue?vue&type=template&id=75e89509"
import script from "./DemandTemplateDetailsSectionDetails.vue?vue&type=script&lang=ts"
export * from "./DemandTemplateDetailsSectionDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script